// @codingStandardsIgnoreFile
/**
 * Save function - the output will be displayed on the frontend
 *
 * @param {object} props
 * @return {domObject}
 */
const save = (props) => {
	return <div className={props.attributes.className}>
		MetaSlider Frontend
	</div>
}

export default save



// WEBPACK FOOTER //
// ./src/admin/assets/js/gutenberg/components/block-save.js